import { render, staticRenderFns } from "./formgroupcheck.vue?vue&type=template&id=27a9a05f&"
import script from "./formgroupcheck.js?vue&type=script&lang=js&"
export * from "./formgroupcheck.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a9a05f')) {
      api.createRecord('27a9a05f', component.options)
    } else {
      api.reload('27a9a05f', component.options)
    }
    module.hot.accept("./formgroupcheck.vue?vue&type=template&id=27a9a05f&", function () {
      api.rerender('27a9a05f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/formgroupcheck.vue"
export default component.exports